import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { Container, Header, Grid, Button, Loader, Segment, Statistic, Divider, Icon, Form, DropdownProps } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";

import TableApp, { ITableAppRender } from "../../components/TableApp";

import errors from "../../Utils/ExtractErrors";
import PrevisionRepository, { IPrevision, IPrevisionParams } from "../../Repositories/PrevisionRepository";
import numberFormat from "../../Utils/NumberFormat";
import { GetUser } from "../../services/auth";
import CustomLoader from "../../components/CustomLoader";

const Prevision: React.FC = () => {

    const date = new Date();
    const [list, setList] = useState<IPrevision[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<IPrevisionParams>({ year: date.getFullYear().toString(), month: (date.getMonth() + 1).toString(), status: "3" });
    const totalQtd = list.reduce((a, b) => a + b.quantidade, 0);

    const { role } = GetUser();

    const optionsMonth = [
        { key: "1", text: "JANEIRO", value: "1" },
        { key: "2", text: "FEVEREIRO", value: "2" },
        { key: "3", text: "MARÇO", value: "3" },
        { key: "4", text: "ABRIL", value: "4" },
        { key: "5", text: "MAIO", value: "5" },
        { key: "6", text: "JUNHO", value: "6" },
        { key: "7", text: "JULHO", value: "7" },
        { key: "8", text: "AGOSTO", value: "8" },
        { key: "9", text: "SETEMBRO", value: "9" },
        { key: "10", text: "OUTUBRO", value: "10" },
        { key: "11", text: "NOVEMBRO", value: "11" },
        { key: "12", text: "DEZEMBRO", value: "12" }
    ];

    const optionsYear = [
        { key: "1", text: "2020", value: "2020" },
        { key: "2", text: "2021", value: "2021" },
        { key: "3", text: "2022", value: "2022" },
        { key: "4", text: "2023", value: "2023" },
        { key: "5", text: "2024", value: "2024" },
        { key: "6", text: "2025", value: "2025" },
        { key: "7", text: "2026", value: "2026" },
    ];

    const optionsStatus = [
        { key: "1", text: "TODOS", value: "2,3,4" },
        { key: "2", text: "REPRESENTANTE", value: "2" },
        { key: "3", text: "REVENDEDOR", value: "3" },
        { key: "4", text: "PRÉ-CONFERIDO", value: "4" }
    ];

    const load = async () => {

        setLoading(true);
        try {

            const response = await PrevisionRepository.PartialMonth({
                year: state.year,
                month: state.month,
                status: state.status
            });

            setList(response);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    };

    useEffect(() => { load() }, []);

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Representante",
            content: (x: IPrevision) => x.representante,
            textAlign: "left",
            width: 14
        },
        {
            header: "Quantidade",
            content: (x: IPrevision) => x.quantidade,
            textAlign: "center",
            width: 2
        },
    ];

    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                {loading ? <Segment><CustomLoader /></Segment> :
                    <Grid columns="equal">
                        <Grid.Row>
                            <Grid.Column>
                                <Header size="huge" content={`Previsão de acertos`} icon="chart line" />
                            </Grid.Column>
                        </Grid.Row>
                        {
                            role === "Admin" &&
                            <Grid.Row>
                                <Grid.Column width="16">
                                    <Segment placeholder>
                                        <Grid columns={2} stackable textAlign='center'>
                                            <Divider vertical></Divider>

                                            <Grid.Row verticalAlign='middle'>
                                                <Grid.Column>
                                                    <Statistic>
                                                        <Statistic.Value>{totalQtd}</Statistic.Value>
                                                        <Statistic.Label><Icon name='boxes' />Quantidade</Statistic.Label>
                                                    </Statistic>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <Statistic>
                                                        <Statistic.Value>{numberFormat.Currency(totalQtd * 190)}</Statistic.Value>
                                                        <Statistic.Label><Icon name='question' />Bruto Previsto</Statistic.Label>
                                                    </Statistic>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </Segment>
                                </Grid.Column>
                            </Grid.Row>
                        }
                        {
                            (role === "Operador" || role === "GerenteS") &&
                            <Grid.Row>
                                <Grid.Column textAlign="center">
                                    <Segment raised color="teal">
                                        <Statistic>
                                            <Statistic.Value>{totalQtd}</Statistic.Value>
                                            <Statistic.Label>Total</Statistic.Label>
                                        </Statistic>
                                    </Segment>
                                </Grid.Column>
                            </Grid.Row>
                        }
                        <Grid.Row>
                            <Grid.Column>
                                <Form>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="month"
                                                placeholder="Selecione o mês"
                                                label="Mês"
                                                options={optionsMonth}
                                                value={state.month}
                                                onChange={onDropdownChange}

                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="year"
                                                placeholder="Selecione o ano"
                                                label="Ano"
                                                options={optionsYear}
                                                value={state.year}
                                                onChange={onDropdownChange}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="status"
                                                placeholder="Selecione o status"
                                                label="Status"
                                                options={optionsStatus}
                                                value={state.status}
                                                onChange={onDropdownChange}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Button
                                    fluid
                                    icon="search"
                                    color="pink"
                                    content="Atualizar"
                                    onClick={load}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Column>
                            <Grid.Row>
                                <TableApp
                                    render={tableRender}
                                    list={list}
                                    loading={loading}
                                />
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>
                }
            </Container>
            <Footer />
        </>
    );
};

export default Prevision;
